<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
  <kendo-grid [kendoGridBinding]="roleList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" [scrollable]="true" [height]="checkGridHeight()">
      <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex">
              <div class="flex-grow-1 mat-panel-headerbar"></div>
              <div class="pagination-container" style="width:25%;"><span style="width:35%;font-weight: bold;" class="eip-mr-15 d-none d-md-block">Business Group :</span>
                  <div style="width:95%;">
                      <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="group_Name" ValueField="group_Id" [dataSource]='businessGroupList' setId="ddMrlBusGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
                      </EIPAutoComplete>
                  </div>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">
                  </kendo-pager-page-sizes>
                  <span>Items</span>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                      <div class="icon-wrap" (click)="toggleFilter()">
                          <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                          <span class="list-icon-name">Filter</span>
                      </div>
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                      </div>
                  </div>
                  <div class="divider-container d-none d-md-block"><span></span></div>
                  <i class="fa fa-save eip-pl-xs-0" (click)=" submitMapped()" aria-hidden="true" id="" title="Save"></i>
              </div>
          </div>
      </ng-template>
      <kendo-grid-column title="Role" field="dedDescription" width="240" [locked]="true" [reorderable]="false">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span [matTooltip]="dataItem.dedDescription">
                  <mat-checkbox [checked]="roleHeader[dataItem.dedId]" (change)="checkAllFeatures($event.checked,dataItem.dedId)">
                  </mat-checkbox>
                  <span class="role-feature-label eip-link" [matTooltip]="dataItem.dedDescription">
                      {{dataItem.dedDescription}}
                  </span>
              </span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column filterable="false" width="110" *ngFor="let feature of featureList" title="{{feature.dedDescription}}">
          <ng-template kendoGridHeaderTemplate let-dataItem>

              <span [matTooltip]="feature.dedDescription">
                  <mat-checkbox [checked]="featureHeader[feature.dedId]" (change)="checkAllRoles($event.checked,feature.dedId)">
                  </mat-checkbox>
                  <span class="eip-ml-5">{{feature.dedDescription}}</span>
              </span>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <mat-checkbox [checked]="isChecked(dataItem.dedId,feature.dedId)" (change)="mapRoleFeature($event.checked,dataItem.dedId,feature.dedId)">
              </mat-checkbox>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column width="1" [locked]="false">
      </kendo-grid-column>
  </kendo-grid>
</div>